import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./PagerBase.module.less";
import { PagerButton } from "./PagerButton";
import { PagerSelect } from "./PagerSelect";

export type PagerBaseAlign =
	| "default"
	| "left"
	| "center"
	| "right";

export type PagerBaseProps = {
	alignment?: PagerBaseAlign;
	trackingId?: string;
	ariaLabel?: string;
};

export const PagerBase = (props: PropsWithChildren<PagerBaseProps>): ReactElement => {
	const {
		alignment = "default",
		trackingId,
		ariaLabel,
		children
	} = props;

	return (
		<nav
			{...setTrackingId(trackingId)}
			aria-label={ariaLabel}
			className={classNames(
				styles.root,
				pagerBaseAlignToStyles[alignment]
			)}
		>
			{children}
		</nav>
	);
};
PagerBase.displayName = "PagerBase";

const pagerBaseAlignToStyles: { [key in PagerBaseAlign]: string | null } = {
	["default"]: null,
	["left"]: styles.root_leftAligned,
	["center"]: styles.root_centerAligned,
	["right"]: styles.root_rightAligned
};

PagerBase.Button = PagerButton;
PagerBase.Select = PagerSelect;